module.exports = __webpack_public_path__ + "img/eseminar.0e49e65.webp";